export default __webpack_public_path__ + "static/KS-cbda5832035cc3cca24442c75ebad1cb.pdf";